import {createSelector} from "reselect";
import {Selectors as CompanySelectors} from 'modules/companies';

export const sliceSelector = state => state.notifs;
export const fetchingSelector = createSelector(sliceSelector, slice => !!slice.fetching);
export const loadingSelector = createSelector(sliceSelector, slice => !!slice.loading);
export const justCreatedSelector = createSelector(sliceSelector, slice => !!slice.justCreated);
export const permissionCanBeGranted = createSelector(sliceSelector, slice => slice.notifStat === 'default');
export const permissionGranted = createSelector(sliceSelector, slice => slice.notifStat === 'granted');
export const showPermissionModal = createSelector(sliceSelector, slice => !!slice.showPermissionModal);
export const notifsHistorySelector = createSelector(sliceSelector, slice => slice.history || []);
export const hasMoreNotifsHistorySelector = createSelector(sliceSelector, slice => !!slice.hasMoreHistory);
export const lastNotifHistorySelector = createSelector(sliceSelector, slice => slice.lastHistory);
export const settingsSelector = createSelector(sliceSelector, CompanySelectors.matchingCompanySelector,
    (slice, cmp) => {
        const settings = slice.settings || {};
        if (cmp && cmp.notif) {
            return {...settings,
                amountLeft: cmp.notif.amountLeft,
                enabled: cmp.notif.enabled,
            }
        }
        return settings;
    }
);
